document.addEventListener("DOMContentLoaded", function() {
    const internalDomains = ["https://mixopro.store"];

    const links = document.querySelectorAll("a");

    links.forEach(link => {
        const url = link.href;

        const isExternal = !internalDomains.some(domain => url.includes(domain));

        if (isExternal) {
            link.setAttribute("rel", "nofollow");
        }
    });
});